import axios from "axios";


//service condicional
const URL_TEST = true; //false para desarrollo, true para produccion
const KEYS = true; //false para desarrollo, true para produccion
export const VERSION_APP = '1.0.0.1';//version de la app web

//version de la app nativo, solo se cambia si hay un cambio en la app nativo
export const VERSION_APP_NATIVO = {
    appVersion: '0.0.1',
};

//version para el cache==> cambiar cada vez que se suba una nueva version
export const VERSION_CACHE = {
    appVersion: '0.0.4',
};

const KEY = (KEYS) ? "dajGdhJ3rRGNMwKRUjmlVFk1hhRh7gdkmvj2hJvGQO4o66e9l0" : "oJ6adF973oSyjnb2xF8wJNROGmvK7sOrBLkkv4afNcPm2PzZXBz";

const URL = (URL_TEST) ? "https://mdw.cabal.coop.py" : "https://mdwpresec.cabal.coop.py";



//------------------------------------------------------------------------------servicio de login
export const postLogin = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/qr/v1/comercio/login",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })

    });
};


//------------------------------------------------------------------------------servicio de GENERAR QR
export const postGenerarQr = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/qr/v1/encript64",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};

//------------------------------------------------------------------------------servicio de Details QR
export const postDetailsQr = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/qr/v1/details",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};

//------------------------------------------------------------------------------servicio de CANCELAR QR
export const postCancelarQr = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/qr/v1/cancelar",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data.header);
            })
            .catch(error => {
                reject(error);
            })

    });
};

//------------------------------------------------------------------------------servicio de Details QR
export const postConsultarPagos = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/qr/v1/pagos/consultar",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};

//------------------------------------------------------------------------------servicio de Buscar por Alias
export const postConsultarPagosAlias = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/spi/v1/transferencia/listar",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};

//------------------------------------------------------------------------------servicio de transferencia por alias
export const postAliasTransferir = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/spi/v1/transferencia/alias/transferir",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};


//------------------------------------------------------------------------------servicio de consulta pagos por alias
export const postConsultaPagoAlias = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/spi/v1/transferencia/consultar",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};


//------------------------------------------------------------------------------servicio de terminos y condiciones
export const postTerminosCondiciones = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/qr/v1/comercio/condiciones",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                //USAR API-KEY Dentro de la cabecera
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};

//------------------------------------------------------------------------------servicio de notificacion token
export const postNotificationTokken = (body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + "/api/spi/v2/transferencia/consultar",
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'API-KEY': KEY
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })

    });
};